// endpoints
import * as orderEndPoints from "../constants/endpoints/order";
// axios
import axiosMainInstance from "../axios/axios";

export const createOrder = (data) => {
  return axiosMainInstance({
    url: orderEndPoints.createOrder,
    method: "POST",
    data,
  });
};

export const getFollowUpOrderDetails = (orderId) => {
  return axiosMainInstance({
    url: orderEndPoints.getFollowUpOrderDetails.replace(":orderId", orderId),
    method: "GET",
  });
};

export const getFreeExpressDeliveryPromoBanner = () => {
  return axiosMainInstance({
    url: orderEndPoints.GET_FREE_EXPRESS_DELIVERY_PROMO,
    method: "GET",
  });
};

export const getDeliverySlots = (data) => {
  return axiosMainInstance({
    url: orderEndPoints.GET_DELIVERY_SLOTS,
    method: "POST",
    data,
  });
};
